import { GoBackHeaderTitle, If } from "components";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import { useGetAuditLogById } from "../../apis";
import { AuditLogResponse } from "../../auditLog.types";
import { AuditLogDetailContent } from "../../components";

import styles from "./AuditLogDetail.module.scss";

const AuditLogDetail = () => {
  const { t } = useTranslation();
  const { auditLogId } = useParams();
  const navigate = useNavigate();

  const { auditLog, isLoading } = useGetAuditLogById(auditLogId as string);

  return (
    <ContentLayout
      title={
        <GoBackHeaderTitle
          title={t("Activity record")}
          onGoBack={() => navigate(-1)}
        />
      }
    >
      <BoxShadowLayout className={styles.detail}>
        <If condition={isLoading}>
          <div className={styles.detail__loader}>
            <ClipLoader size={30} color="#fb3973" />
          </div>
        </If>

        <If condition={!isLoading && !!auditLog}>
          <AuditLogDetailContent auditLog={auditLog as AuditLogResponse} />
        </If>

        <If condition={!isLoading && !auditLog}>
          <p className={styles.detail__notFound}>
            {t("Activity record not found")}
          </p>
        </If>
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default AuditLogDetail;
